import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import BodyView from "@/layout/BodyView.vue";
import AuthView from "@/components/common/block/auth/AuthView.vue";

import LoginPage from "@/components/common/block/auth/LoginPage.vue";

import indexAddProduct from "@/pages/ecommerce/indexAddProduct.vue";
import indexProductList from "@/pages/ecommerce/indexProductList.vue";
import IndexCondiment from '@/pages/ecommerce/indexCondiment.vue';
import IndexAddMenupage from '@/pages/ecommerce/indexAddMenupage.vue';
import Indexpagelist from '@/pages/ecommerce/indexpagelist.vue';
import IndexAddCondiment from '@/pages/ecommerce/indexAddCondiment.vue';
import IndexProductCategory from '@/pages/ecommerce/indexProductCategory.vue';
import IndexAddCategory from '@/pages/ecommerce/indexAddCategory.vue';
import IndexCatalog from '@/pages/ecommerce/indexCatalog.vue';
import IndexAddCataglog from '@/pages/ecommerce/indexAddCataglog.vue';

import TaxesPage from '@/pages/management/taxesPage.vue';

import productVariationPage from '@/pages/management/productVariationPage.vue';

import DepartmentsPage from '@/pages/management/departmentsPage.vue';
import departmentsBasic from '@/components/managementPages/dapartmentsPage/departmentsBasic.vue';
import departmentsAppearance from '@/components/managementPages/dapartmentsPage/departmentsAppearance.vue';

import productsPage from '@/pages/management/productsPage.vue';
import productBasic from '@/components/managementPages/productsPage/productBasic.vue';
import productStock from '@/components/managementPages/productsPage/productStock.vue';
import productScale from '@/components/managementPages/productsPage/productScale.vue';
import productSetItems from '@/components/managementPages/productsPage/productSetItems.vue';
import productAppearance from '@/components/managementPages/productsPage/productAppearance.vue';
import productPriceLevels from '@/components/managementPages/productsPage/productPriceLevels.vue';
import productCondiments from '@/components/managementPages/productsPage/productCondiments.vue';
import productLinkGroups from '@/components/managementPages/productsPage/productLinkGroups.vue';
import productVariation from '@/components/managementPages/productsPage/productVariation.vue';
import productMiscellneous from '@/components/managementPages/productsPage/productMiscellneous.vue';
import ProductDetails from '@/components/managementPages/productsPage/productDetails.vue';
import productListTable from '@/components/managementPages/productsPage/productListTable.vue';

import productGroupsPage from '@/pages/management/productGroupsPage.vue';
import productGroupsBasic from '@/components/managementPages/productGroupsPages/productGroupsBasic.vue';
import productGroupsNavLinks from '@/components/managementPages/productGroupsPages/productGroupsNavLinks.vue';
import productGroupsAppearance from '@/components/managementPages/productGroupsPages/productGroupsAppearance.vue';

import condimentsPage from '@/pages/management/condimentsPage.vue';
import condimentsBasic from '@/components/managementPages/condimentsPage/condimentsBasic.vue';
import condimentsAppearance from '@/components/managementPages/condimentsPage/condimentsAppearance.vue';

import StaticCondimentPage from '@/pages/management/staticCondimentPage.vue';

import promotionPage from '@/pages/management/promotionPage.vue';
import PromotionBasic from '@/components/managementPages/PromotionPage/promotionBasic.vue';
import PromotionTimeControl from '@/components/managementPages/PromotionPage/promotionTimeControl.vue';
import PromotionTrigger from '@/components/managementPages/PromotionPage/promotionTrigger.vue';
import PromotionType from '@/components/managementPages/PromotionPage/promotionType.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    redirect: '/management/products',
  },
  {
    path: "/auth",
    component: AuthView,
    children: [
      {
        path: "login",
        name: "login",
        component: LoginPage,
        meta: {
          title: 'OFD E-Menu Login',
        }
      },

    ]
  },
  {
    path: "/Emenu",
    component: BodyView,
    children: [
      // Product - G
      {
        path: "product_list",
        name: "Product List",
        component: indexProductList,
        meta: {
          title: 'Product List',
        }
      },
      {
        path: "add_product",
        name: "Add Product",
        component: indexAddProduct,
        meta: {
          title: 'Add Product',
        }
      },
      {
        path: "edit_product/EditProduct/:productId",
        name: "Edit Product",
        component: indexAddProduct,
        meta: {
          title: 'Edit Product',
        },
        props: true
      },
      // Condiment - G
      {
        path: "condiment_list",
        name: "Condiment List",
        component: IndexCondiment,
        meta: {
          title: 'Condiment List',
        }
      },
      {
        path: "addcondiment_list",
        name: "Add Condiment",
        component: IndexAddCondiment,
        meta: {
          title: 'Add Condiment',
        }
      },
      {
        path: 'edit_condiment/EditCondiment/:id',
        name: 'Edit Condiment',
        component: IndexAddCondiment,
        meta: {
          title: 'Edit Condiment',
        },
        props: true,
      },
      // Page - G
      {
        path: "page_list",
        name: "Page List",
        component: Indexpagelist,
        meta: {
          title: 'Page List',
        }
      },
      {
        path: "add_page",
        name: "Add Page",
        component: IndexAddMenupage,
        meta: {
          title: 'Add Page',
        }
      },
      {
        path: "edit_page/EditPage/:pageId",
        name: "Edit Page",
        component: IndexAddMenupage,
        meta: {
          title: 'Edit Page',
        },
        props: true,
      },
      // Category - G
      {
        path: "category_list",
        name: "Category List",
        component: IndexProductCategory,
        meta: {
          title: 'Category List',
        }
      },
      {
        path: "add_category",
        name: "Add Category",
        component: IndexAddCategory,
        meta: {
          title: 'Add Category',
        }
      },
      {
        path: 'edit_category/EditCategory/:groupId',
        name: 'Edit Category',
        component: IndexAddCategory,
        meta: {
          title: 'Edit Category',
        },
        props: true,
      },
      // Catalog - G
      {
        path: "catalog_list",
        name: "Catalog List",
        component: IndexCatalog,
        meta: {
          title: 'Catalog List',
        }
      },
      {
        path: "addcatalog_list",
        name: "Add Catalog",
        component: IndexAddCataglog,
        meta: {
          title: 'Add Catalog',
        }
      },
      {
        path: "edit_catalog/EditCatalog/:catalogId",
        name: "Edit Catalog",
        component: IndexAddCataglog,
        meta: {
          title: 'Edit Catalog',
        },
        props: true,
      },
    ]
  },
  {
    path: "/management",
    component: BodyView,
    children: [
      {
        path: "taxes",
        name: "taxes",
        component: TaxesPage,
        meta: {
          title: 'OFD | Taxes',
        }
      },
      {
        path: "product_variation",
        name: "product_variation",
        component: productVariationPage,
        meta: {
          title: 'OFD | Product Variation',
        }
      },
      {
        path: "products",
        name: "products",
        component: productsPage,
        meta: {
          title: 'OFD | Products',
        },
        children: [
          {
            path: "",
            name: "productListTable",
            component: productListTable,
          },
          {
            path: "details",
            name: "details",
            component: ProductDetails,
            children: [
              {
                path: ":id",
                name: "productBasic",
                component: productBasic,
              },
              {
                path: "stock/:id",
                name: "productStock",
                component: productStock,
              },
              {
                path: "scale/:id",
                name: "productScale",
                component: productScale,
              },
              {
                path: "set_items/:id",
                name: "productSetItems",
                component: productSetItems,
              },
              {
                path: "appearance/:id",
                name: "productAppearance",
                component: productAppearance,
              },
              {
                path: "price_levels/:id",
                name: "productPriceLevels",
                component: productPriceLevels,
              },
              {
                path: "condiments/:id",
                name: "productCondiments",
                component: productCondiments,
              },
              {
                path: "link_groups/:id",
                name: "productLinkGroups",
                component: productLinkGroups,
              },
              {
                path: "variation/:id",
                name: "productVariation",
                component: productVariation,
              },
              {
                path: "miscellaneous/:id",
                name: "productMiscellaneous",
                component: productMiscellneous,
              }
            ]
          },

        ]
      },
      {
        path: "departments",
        name: "departments",
        component: DepartmentsPage,
        meta: {
          title: 'OFD | Departments',
        },
        children: [
          {
            path: "",
            name: "departmentsBasic",
            component: departmentsBasic,
          },
          {
            path: "appearance",
            name: "departmentsAppearance",
            component: departmentsAppearance,
          }
        ]
      },
      {
        path: "product_groups",
        name: "product_groups",
        component: productGroupsPage,
        meta: {
          title: 'OFD | Product Groups',
        },
        children: [
          {
            path: "",
            name: "productGroupsBasic",
            component: productGroupsBasic,
          },
          {
            path: "nav_links",
            name: "productGroupsNavLinks",
            component: productGroupsNavLinks,
          },
          {
            path: "appearance",
            name: "productGroupsAppearance",
            component: productGroupsAppearance,
          }
        ]
      },
      {
        path: "condiments",
        name: "condiments",
        component: condimentsPage,
        meta: {
          title: 'OFD | Condiments',
        },
        children: [
          {
            path: "",
            name: "condimentsBasic",
            component: condimentsBasic,
          },
          {
            path: "appearance",
            name: "condimentsAppearance",
            component: condimentsAppearance,
          }
        ]
      },
      {
        path: "static_condiment",
        name: "static_condiment",
        component: StaticCondimentPage,
        meta: {
          title: 'OFD | Static Condiment',
        }
      },
      {
        path: "promotion",
        name: "promotion",
        component: promotionPage,
        meta: {
          title: 'OFD | Promotion',
        },
        children: [
          {
            path: "",
            name: "basic",
            component: PromotionBasic,
          },
          {
            path: "time_control",
            name: "time_control",
            component: PromotionTimeControl,
          },
          {
            path: "trigger",
            name: "trigger",
            component: PromotionTrigger,
          },
          {
            path: "type",
            name: "type",
            component: PromotionType,
          },
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta && typeof to.meta.title === 'string') {
    document.title = to.meta.title;
  }
  next();
});

export default router;
